module.exports = __webpack_public_path__ + "img/lou2-ears.7bdf01f4.png";